import dayjs from "dayjs";
import CryptoJS from "crypto-js";
import { uploadDocOnS3 } from "../aws/commonFunc";
const isValidURL = /^(https?:\/\/)?([^\s$.?#].[^\s]*)$/i;
const cryptoSecret = process.env.REACT_APP_CRYPTOSECRET;

export async function delay(milliseconds) {
  await new Promise((resolve) => setTimeout(resolve, milliseconds));
}

export const disableFutureDates = (current) => {
  return current && current > dayjs().endOf('day'); // Disable future dates
};

export const encryptSecretHex = (value) => {
  if (!value || !cryptoSecret) {
    console.warn("encryptSecretHex: Missing value or REACT_APP_CRYPTOSECRET");
    return value || "";
  }
  return CryptoJS.AES.encrypt(value, cryptoSecret).toString();
}

export const decryptSecretHex = (value) => {
  // Return empty string if value is missing, not a valid encrypted string, or if secret is not configured
  if (!value || !cryptoSecret || value === "NA" || value === "null" || value === "undefined") {
    return "";
  }
  try {
    var bytes = CryptoJS.AES.decrypt(value, cryptoSecret);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("decryptSecretHex: Decryption failed", error);
    return "";
  }
}

export const uploadDoc = async (payload, type) => {
  console.log(payload, type, 'payload, type');


  if (type === 'client' && payload?.length) {
    try {
      const uploadResults = await Promise.all(
        payload.map(async (record) => {
          if (!record.document || record.document.length === 0) {
            return {
              ...record,
              type: type,
              illness: record.illness,
              medicineName: record.medicineName,
              document: ''
            };
          }
          if (isValidURL?.test(record.document)) {
            return {
              ...record,
              type: type,
              illness: record.illness,
              medicineName: record.medicineName,
              document: record.document
            };
          }

          // Otherwise, upload each document
          const uploadDocs = await Promise.all(
            record.document.map(doc => uploadDocOnS3(doc.originFileObj))
          );

          return {
            ...record,
            type: type,
            illness: record.illness,
            medicineName: record.medicineName,
            document: uploadDocs[0] || ''
          };
        })
      );
      return uploadResults;
    } catch (error) {
      console.error("Error in client upload:", error);
      return { error: true, message: "Failed to upload client documents", details: error };
    }
  }

  else if (type === 'nominee' && payload?.length) {
    try {
      const nomineeResults = await Promise.all(
        payload.map(async (nominee) => {
          const medicalHistoryWithDocs = await Promise.all(
            nominee.medicalHistory.map(async (historyRecord) => {
              if (!historyRecord.document || historyRecord.document.length === 0) {
                return {
                  type: type,
                  illness: historyRecord.illness,
                  medicineName: historyRecord.medicineName,
                  document: ''
                };
              }

              if (isValidURL?.test(historyRecord.document)) {
                return {
                  type: type,
                  illness: historyRecord.illness,
                  medicineName: historyRecord.medicineName,
                  document: historyRecord.document
                };
              }


              const uploadDocs = await Promise.all(
                historyRecord.document.map((doc) => uploadDocOnS3(doc.originFileObj))
              );
              return {
                type: type,
                illness: historyRecord.illness,
                medicineName: historyRecord.medicineName,
                document: uploadDocs[0] || ''
              };
            })
          );

          return {
            name: nominee.name,
            dob: nominee.dob,
            relation: nominee.relation,
            medicalHistory: medicalHistoryWithDocs
          };
        })
      );

      console.log(nomineeResults, 'Nominee results with URLs');
      return nomineeResults;
    } catch (error) {
      console.error("Error in nominee upload:", error);
      return { error: true, message: "Failed to upload nominee documents", details: error };
    }
  }

  else {
    return { error: true, message: "Invalid type or empty payload" };
  }
};


export function nextDueDate(startDate, installments, maturityEndDate) {

  const start = dayjs(startDate);
  const current = dayjs();
  const maturityEnd = dayjs(maturityEndDate);

  if (current.isAfter(maturityEnd)) {
    return null;
  }

  for (const installment of installments) {
    let dueDate = dayjs()
      .year(current.year())
      .month(installment.dueMonth - 1)
      .date(installment.dayOfMonth)

    if (!dueDate.isValid() || (installment.dueMonth === 2 && installment.dayOfMonth > 28)) {
      dueDate = dayjs()
        .year(current.year())
        .month(installment.dueMonth - 1)
        .endOf('month');

    }

    if (dueDate.isAfter(start) && dueDate.isAfter(current)) {
      return dueDate.format('DD/MM/YYYY');
    }
  }

  for (const installment of installments) {
    let dueDate = dayjs()
      .year(current.year() + 1)
      .month(installment.dueMonth - 1)
      .date(installment.dayOfMonth)

    if (!dueDate.isValid() || (installment.dueMonth === 2 && installment.dayOfMonth > 28)) {
      dueDate = dayjs()
        .year(current.year())
        .month(installment.dueMonth - 1)
        .endOf('month');
    }

    if (dueDate.isAfter(start) && dueDate.isAfter(current)) {
      return dueDate.format('DD/MM/YYYY');
    }
  }

  return null;
}